<template>
  <list ref="list">
    <el-table-column slot="column" min-width="80" align="center">
      <template slot="header" slot-scope="{}">
        <el-badge
          :value="datalist.length"
          :max="9"
          :hidden="datalist.length == 0"
        >
          <i class="el-icon-shopping-bag-2" style="font-size: 20px" />
        </el-badge>
      </template>
      <template slot-scope="{ row }">
        <el-link
          v-if="!Exists(row)"
          type="danger"
          class="el-icon-circle-plus"
          @click="onInsert(row)"
        />
      </template>
    </el-table-column>
    <el-button slot="operate-r" size="small" type="danger" @click="onSubmit"
      >确定选中的商品</el-button
    >
  </list>
</template>


<script>
export default {
  components: { list: () => import("./list.vue") },
  data() {
    return {
      datalist: [],
    };
  },
  props: {
    callback: { type: Function },
    layerid: { type: String, default: null },
  },
  computed: {
    Exists() {
      return (row) => {
        return this.datalist.filter((x) => x.Code == row.Code).length > 0;
      };
    },
  },
  methods: {
    onInsert(row) {
      this.datalist.push(row);
    },
    onRemove(row) {
      this.datalist.splice(
        this.datalist.findIndex((item) => item.Code === row.Code),
        1
      );
    },
    onSubmit() {
      this.datalist.map((row) => {
        row.Quantity = 1;
      });
      typeof this.callback == "function" && this.callback(this.datalist);
      this.$layer.close(this.layerid);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-badge) {
  padding: 5px;
  &__content.is-fixed {
    top: 8px;
    right: 18px;
  }
}
</style>